"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export const classNameStyles = {
  default: "",
  admin:
    "w-full p-3 border border-gray-3 rounded-md bg-white text-black placeholder-gray-4 focus:border-primary-main focus:ring-2 focus:ring-primary-main/20 transition-colors",
} as const;

type StyleKey = keyof typeof classNameStyles;

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  classType?: StyleKey;
  label?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, classType = "default", label, ...props }, ref) => {
    const classes = cn(
      // baseline styles
      "",
      // variant styles
      classType ? classNameStyles[classType] : undefined,
      // allow overrides
      className
    );

    const inputElement = <input ref={ref} className={classes} {...props} />;

    if (label) {
      return (
        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium pl-3 text-gray-700">
            {label}
            <span className="text-secondary-main">*</span>
          </label>
          {inputElement}
        </div>
      );
    }

    return inputElement;
  }
);

Input.displayName = "Input";
